import heartBeat from '../assets/lottie/heart-beat.json';
import puzzle from '../assets/lottie/puzzle.json';
import sleepyMoon from '../assets/lottie/sleepy-moon.json';
import step3Workout from '../assets/lottie/step3-workout.json';
import halfWaterCircle from '../assets/lottie/half-water-circle.json';
import journaling from '../assets/lottie/journaling.json';
import habits from '../assets/lottie/habits.json';

/** Lottie animations for focused toolbox tools on the homepage. */
export const focusedToolLotties = [
  heartBeat,
  puzzle,
  sleepyMoon,
  step3Workout,
  halfWaterCircle,
  journaling,
  habits,
];
